module.exports = __webpack_public_path__ + "img/1572284537.4f2f411b.jpg";